<div class="container">
    <header>
      <h1>Clarity PREVENTION - Política de Privacidade</h1>
      <div class="meta">Última atualização: 13 de outubro de 2025</div>
    </header>

    <section>
      <h2>1. Introdução</h2>
      <p>Bem-vindo ao <strong>Clarity PREVENTION - Calculadora de Risco Cardiovascular</strong> ("Aplicativo"). Este aplicativo foi desenvolvido para auxiliar profissionais de saúde no cálculo do risco cardiovascular de pacientes.</p>
      <p>A calculadora Clarity PREVENTION é baseada nas seguintes diretrizes científicas internacionalmente reconhecidas:</p>
      <ul>
        <li>ABC Cardiol - Diretriz Brasileira de Hipertensão Arterial, 2025</li>
        <li>The American Heart Association (AHA) PREVENT™</li>
        <li>European Society of Cardiology (ESC)</li>
        <li>ABESO - Associação Brasileira para o Estudo da Obesidade e da Síndrome Metabólica</li>
        <li>ADA - American Diabetes Association</li>
        <li>SBD - Sociedade Brasileira de Diabetes</li>
      </ul>
      <p>Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos as informações quando você utiliza nosso app.</p>
    </section>

    <section>
      <h2>2. Informações que coletamos</h2>

      <h3>2.1 Dados clínicos anônimos</h3>
      <p>Coletamos os seguintes dados clínicos inseridos no aplicativo para fins de pesquisa científica:</p>
      <ul>
        <li>Idade</li>
        <li>Sexo</li>
        <li>Peso</li>
        <li>Altura</li>
        <li>IMC (Índice de Massa Corporal)</li>
        <li>HbA1c (Hemoglobina Glicada)</li>
        <li>Colesterol Total</li>
        <li>Colesterol HDL</li>
        <li>Colesterol não-HDL</li>
        <li>Pressão Arterial Sistólica</li>
        <li>Pressão Arterial Diastólica</li>
        <li>Creatinina</li>
        <li>Taxa de Filtração Glomerular</li>
        <li>Albumina</li>
        <li>LDL</li>
        <li>Proteína C‑Reativa</li>
        <li>Lp(a)</li>
        <li>Escore de Cálcio</li>
        <li>Uso de medicamentos (hipolipemiantes, estatina, anti-hipertensivos)</li>
        <li>Histórico de diabetes mellitus e tabagismo</li>
      </ul>

      <h3>2.2 Dados NÃO coletados</h3>
      <p>Importante: O aplicativo <strong>NÃO</strong> coleta as seguintes informações:</p>
      <ul>
        <li>Número do CRM (usado apenas para validação local de acesso)</li>
        <li>Nome do paciente (quando fornecido, permanece apenas no dispositivo)</li>
        <li>Qualquer informação que permita identificar o paciente ou o médico</li>
        <li>Dados de localização</li>
        <li>Informações de contato</li>
      </ul>

      <h3>2.3 Dados técnicos</h3>
      <p>Nenhum dado técnico identificável (endereço IP, identificador de dispositivo, etc.) é coletado ou armazenado.</p>
    </section>

    <section>
      <h2>3. Como usamos as informações</h2>

      <h3>3.1 Finalidade</h3>
      <p>Os dados clínicos anônimos coletados são utilizados exclusivamente para:</p>
      <ul>
        <li>Pesquisa científica e epidemiológica</li>
        <li>Análise estatística de prevalência de fatores de risco cardiovascular</li>
        <li>Melhoria da ferramenta de cálculo de risco</li>
        <li>Desenvolvimento de estudos sobre saúde cardiovascular na população</li>
      </ul>

      <h3>3.2 Anonimização</h3>
      <p>Todos os dados são coletados de forma completamente anônima. Não há qualquer forma de rastreamento que permita identificar:</p>
      <ul>
        <li>O paciente cujos dados foram inseridos</li>
        <li>O profissional de saúde que utilizou o aplicativo</li>
        <li>A localização geográfica dos dados</li>
      </ul>
    </section>

    <section>
      <h2>4. Armazenamento e segurança</h2>

      <h3>4.1 Armazenamento Local</h3>
      <p>O aplicativo funciona offline first. Os dados inseridos são armazenados inicialmente no dispositivo do usuário de forma criptografada.</p>

      <h3>4.2 Armazenamento em Nuvem</h3>
      <p>Os dados clínicos anônimos são sincronizados com o Firebase (Google Cloud Platform) para:</p>
      <ul>
        <li>Backup seguro</li>
        <li>Agregação para análise estatística</li>
        <li>Pesquisa científica</li>
      </ul>

      <h3>4.3 Medidas de segurança</h3>
      <p>Implementamos as seguintes medidas de segurança:</p>
      <ul>
        <li>Criptografia de dados em trânsito (HTTPS/TLS)</li>
        <li>Criptografia de dados em repouso</li>
        <li>Anonimização irreversível dos dados</li>
        <li>Acesso restrito aos dados agregados</li>
        <li>Infraestrutura em nuvem com certificações de segurança (Google Cloud)</li>
      </ul>
    </section>

    <section>
      <h2>5. Compartilhamento de dados</h2>

      <h3>5.1 Dados anônimos para pesquisa</h3>
      <p>Os dados anônimos agregados podem ser:</p>
      <ul>
        <li>Utilizados em publicações científicas</li>
        <li>Compartilhados com instituições de pesquisa parceiras</li>
        <li>Apresentados em congressos e eventos científicos</li>
      </ul>
      <p>Nenhum dado individual ou identificável será compartilhado.</p>

      <h3>5.2 Não comercializamos dados</h3>
      <p>Não vendemos, alugamos ou comercializamos quaisquer dados coletados pelo aplicativo.</p>
    </section>

    <section>
      <h2>6. Geração de relatórios PDF</h2>
      <p>O aplicativo permite gerar relatórios em PDF com os resultados do cálculo de risco cardiovascular. Estes relatórios:</p>
      <ul>
        <li>São gerados localmente no dispositivo</li>
        <li>Podem conter o nome do paciente (se fornecido pelo médico)</li>
        <li>Ficam sob responsabilidade exclusiva do profissional de saúde</li>
        <li>Não são armazenados ou transmitidos pelo aplicativo</li>
        <li>Devem ser gerenciados conforme as normas da LGPD e do Conselho Federal de Medicina</li>
      </ul>
    </section>

    <section>
      <h2>7. Direitos dos usuários</h2>

      <h3>7.1 Acesso e exclusão</h3>
      <p>Como os dados coletados são completamente anônimos, não é possível:</p>
      <ul>
        <li>Identificar dados específicos de um usuário</li>
        <li>Solicitar exclusão de dados específicos já sincronizados</li>
      </ul>

      <h3>7.2 Desinstalação</h3>
      <p>Ao desinstalar o aplicativo, todos os dados armazenados localmente no dispositivo são removidos.</p>
    </section>

    <section>
      <h2>8. Base Legal (LGPD)</h2>
      <p>O tratamento de dados anônimos para pesquisa científica está fundamentado nas seguintes bases legais da Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018):</p>
      <ul>
        <li>Art. 7º, IV - Para a realização de estudos por órgão de pesquisa</li>
        <li>Art. 13 - Dados anonimizados não são considerados dados pessoais para os efeitos da LGPD</li>
      </ul>
    </section>

    <section>
      <h2>9. Uso profissional</h2>
      <p>Este aplicativo destina-se exclusivamente a profissionais de saúde devidamente habilitados. O usuário declara:</p>
      <ul>
        <li>Ser profissional de saúde com CRM ativo</li>
        <li>Utilizar o aplicativo em conformidade com as normas éticas da profissão</li>
        <li>Responsabilizar-se pelo uso adequado dos dados de pacientes</li>
        <li>Seguir as diretrizes do Conselho Federal de Medicina sobre prontuários e documentos médicos</li>
      </ul>
    </section>

    <section>
      <h2>10. Menores de idade</h2>
      <p>Este aplicativo não é direcionado a menores de 18 anos e não coleta intencionalmente dados de menores.</p>
    </section>

    <section>
      <h2>11. Alterações da política</h2>
      <p>Reservamo-nos o direito de atualizar esta Política de Privacidade periodicamente. Notificaremos os usuários sobre alterações significativas através de:</p>
      <ul>
        <li>Atualização da data no topo deste documento</li>
        <li>Notificação no aplicativo</li>
      </ul>
    </section>

    <section>
      <h2>12. Contato</h2>
      <p>Para questões sobre esta Política de Privacidade ou sobre o tratamento de dados, entre em contato:</p>
      <p><strong>E-mail: </strong> <a href="mailto:clarityhealth21@gmail.com">clarityhealth21@gmail.com</a></p>
    </section>

    <section>
      <h2>13. Consentimento</h2>
      <p>Ao utilizar o Clarity PREVENTION, você reconhece ter lido e compreendido esta Política de Privacidade e concorda com a coleta e uso de dados anônimos conforme descrito.</p>
      <p><strong>Versão:</strong> 1.0<br/><strong>Data de vigência:</strong> 13 de outubro de 2025</p>
    </section>

    <footer>
      <p>Clarity PREVENTION — Política de Privacidade</p>
    </footer>
  </div>
